export const getEventClientCoordinates = event => {
  const rect = event.target.getBoundingClientRect();
  const xCoordinate = event.clientX - rect.left;
  const yCoordinate = event.clientY - rect.top / 2;
  return [xCoordinate, yCoordinate];
};

// find the map feature at the specified long lat
export const getTargetMapFeature = (map, lngLat) => {
  const point = map.project(lngLat);
  const foundFeatures = map.queryRenderedFeatures(point);
  // Find feature with the lowest source number
  const targetFeature = foundFeatures.reduce(
    (lowest, feature) => {
      const { source } = feature.layer;
      const sourceNum = source.match(/\d+$/);
      const number = sourceNum ? parseInt(sourceNum[0], 10) : Infinity;
      return number < (lowest.number || Infinity)
        ? { feature, number }
        : lowest;
    },
    { number: Infinity }
  ).feature;
  return targetFeature;
};
